import _ from 'lodash';

type TState = {
    [apiName: string]: {
        data: any;
        pending: boolean;
        method?: string;
    };
};
type TAction = { type: string; response: any };

export function apiReducer(
    { apiName, apiMethod }: { apiName: string; apiMethod: string },
    state: TState,
    action: TAction
) {
    const apiStateName = apiName.toLowerCase();

    switch (action.type) {
        case `api/GET_${apiName} [pending]`:
        case `api/POST_${apiName} [pending]`:
            return {
                ...state,
                [apiStateName]: {
                    data: _.get(state, `${apiStateName}.data`),
                    pending: action.response.pending,
                    method: apiMethod === 'POST' ? 'POST' : undefined
                }
            };

        case `api/GET_${apiName} [success]`:
        case `api/GET_${apiName} [fail]`:
        case `api/POST_${apiName} [success]`:
        case `api/POST_${apiName} [fail]`:
            return {
                ...state,
                [apiStateName]: action.response
            };

        case `api/PUT_${apiName} [pending]`:
        case `api/PUT_${apiName} [success]`:
        case `api/PUT_${apiName} [fail]`:
        case `api/DELETE_${apiName} [pending]`:
        case `api/DELETE_${apiName} [success]`:
        case `api/DELETE_${apiName} [fail]`:
            return {
                ...state,
                [apiStateName]: {
                    data: _.get(state, `${apiStateName}.data`),
                    pending: action.response.pending,
                    method: apiMethod
                }
            };
    }
}
